import { render, staticRenderFns } from "./FetchVerificationCode.vue?vue&type=template&id=65a2af51&scoped=true&"
import script from "./FetchVerificationCode.vue?vue&type=script&lang=js&"
export * from "./FetchVerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./FetchVerificationCode.vue?vue&type=style&index=0&id=65a2af51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2af51",
  null
  
)

export default component.exports